enum ApplicationActionTypes {
	GET_APPLICATION = "GET_APPLICATION",
	GET_ALL_APPLICATION = "GET_ALL_APPLICATION",
	GET_ARCHIVE_APPLICATIONS = "GET_ARCHIVE_APPLICATIONS",
	UPDATE_APPLICATION = "UPDATE_APPLICATION",
	SET_APPLICATION_ERROR = "SET_APPLICATION_ERROR",
	SELECTED_APPLICATION_ID = "SELECTED_APPLICATION_ID",
	DELETED_APPLICATION = "DELETED_APPLICATION",
}

export default ApplicationActionTypes;
